import { Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

@tag("nw-download-btn")
export class NWDownloadBtn extends Component {
  static css = [tailwind];

  private handleOnClick() {
    window.print();
  }

  render() {
    return (
      <div class="print:hidden fixed z-50 top-0 py-2 cursor-pointer transition-colors text-white shadow-xs hover:bg-brand-700 text-center font-semibold right-0 left-0 bg-leather">
        <div onClick={this.handleOnClick}>
          <div class="w-fit flex items-center mx-auto justify-center space-x-4">
            <span class="relative flex h-3 w-3">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-gray-100 opacity-75"></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-200"></span>
            </span>
            <div class="block">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
